function toLowerMaybe(str, config) {
  return config.getOptionalBoolean(
    "techdocs.legacyUseCaseSensitiveTripletPaths"
  ) ? str : str.toLocaleLowerCase("en-US");
}

export { toLowerMaybe };
//# sourceMappingURL=helpers.esm.js.map
